<template>
  <div class="container-fluid">
    <div class="row text-center d-print-none">
      <div class="col col-1 offset-lg-1 d-flex">
        <router-link :to="getBackUrl()" class="mr-auto">
          <button class="btn btn pl-0">
            <icon :icon="['fad', 'arrow-circle-left']"/>
            Back
          </button>
        </router-link>
      </div>
      <div class="col col-11 col-lg-8 d-flex pl-1 pr-1">
        <button class="btn" v-on:click="toggleFullscreen" title="Toggle fullscreen">
          <icon :icon="['fad', 'expand']"/>
          <span v-if="fullscreen === true">Close fullscreen</span>
          <span v-else="fullscreen">Fullscreen</span>
        </button>
        <router-link class="btn mx-auto" :to="'/viewer/' + poster.abstract_id" title="Switch to presentation">
          <icon :icon="['fad', 'file-pdf']"/>
          Presentation
        </router-link>
        <router-link class="btn" :to="'/viewer/video/' + poster.abstract_id" title="Switch to video"
                     v-if="poster.content.video != null">
          <icon :icon="['fad', 'video']" class="text-danger"/>
          Video
        </router-link>
        <a class="btn" :href="poster.docWebsite" target="_blank"
           v-if="poster.docWebsite != null" title="open website">
          <icon :icon="['fad', 'external-link-alt']"/>
          Website(external)
        </a>
        <button class="btn ml-auto" v-print>
          <icon :icon="['fad', 'print']"/>
          Print
        </button>
      </div>
    </div>
    <div class="row d-none d-print-inline">
      <div class="col d-flex">
        <img src="../assets/img/banner.png" class="img-fluid d-block mx-auto">
      </div>
    </div>
    <div class="row mt-3 d-print-inline">
      <div class="col col-lg-8 offset-lg-2">
        <h4>{{poster.presentation_code}} <span v-html="poster.title"></span></h4>
        <div v-html="poster.template"></div>
      </div>
    </div>
    <div class="row mt-3 mb-2 d-print-inline">
      <div class="col text-center smaller">
        All authors, affiliations and abstracts have been published as submitted
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapGetters} from 'vuex'

  export default {
    name: "ViewerAbstract",
    computed: {
      ...mapState({
        fullscreen: 'fullscreen'
      }),
      ...mapGetters({
        poster: 'poster'
      }),
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions({
        getPosterById: 'getPosterById',
      }),
      getBackUrl() {
        return '/view/' + this.$route.params.id;
      },
      toggleFullscreen() {
        this.$store.state.fullscreen = !this.$store.state.fullscreen;
      },
    },
    mounted() {
      this.$store.state.fullscreen = true;
    },
    created() {
      this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'viewer/abstract', this.$route.params.id);
      this.getPosterById(this.$route.params.id);
    }
  }
</script>

<style scoped>
  @media print {
    .col {
      page-break-inside: auto !important;
    }
  }
</style>
